var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lots-list tab-table p-2"},[_c('relations-table',{attrs:{"exclude-columns":['related_to_customer_uuid', 'related_to_receipt_uuid'],"exclude-search-fields":['related_to_customer_uuid']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }